// src/constants/policies.js
// New file: Centralizes policy options (allowed/not_allowed) for smoking, visitors, pets.

export const policyOptions = [
  { value: 'allowed', ar: 'مسموح', en: 'Allowed' },
  { value: 'not_allowed', ar: 'غير مسموح', en: 'Not Allowed' },
];